/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-15 12:23:42
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-01 14:22:44
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-01 09:30:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/config.ts
 */

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.sider.settings'),
  },
];

export { breadcrumbData };
